import React, { Component } from 'react';
import SwitchComponent from './SwitchComponent';
import { Typography } from '@material-ui/core';
import * as ValidationUtils from '../../utils/ValidationUtils';

export default class OfertaTarjetaComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      seleccionado: true,
    };
  }

  onSelectionChange = (value) => {
    if (this.props.onSelectionChange) {
      this.props.onSelectionChange(value);
    }
  };

  render() {
    return (
      <div className="ofertaTarjetas">
        <div className="textosTarjetas">
          <img className="tarjetas" src={require('../../images/master.png')} alt="tarjeta" />
          <div>
            <Typography className="seleccionado">{this.props.producto.nombreProducto}</Typography>
            <Typography>Cupo $ {ValidationUtils.formatMontoWithZero(this.props.producto.cupoTotal)}</Typography>
          </div>
        </div>

        <SwitchComponent checked={this.props.producto.selected} onChange={this.onSelectionChange} />
      </div>
    );
  }
}
